import { loadLocale } from "@smart/itops-locale-dom";
import { Modal } from "@smart/itops-sb-design-system-dom";

type DeactivateFormModalProps = {
  open: boolean;
  loading?: boolean;
  onClose: () => void;
  onConfirm: () => Promise<void>;
};

export const DeactivateFormModal = ({
  open,
  loading,
  onClose,
  onConfirm,
}: DeactivateFormModalProps) => {
  const { terms } = loadLocale();

  return (
    <Modal
      dataTestId="deactivate-form-modal"
      header={{
        text: `Make form Inactive?`,
        icon: "solidGlobe",
        iconBgColor: "bg-orange-200",
      }}
      open={open}
      onClose={onClose}
      loading={loading}
      closeOptions={{
        escapeKey: false,
        clickOutside: false,
      }}
      footer={{
        buttons: [
          {
            text: "Cancel",
            type: "button",
            variant: "secondarySubtle",
            disabled: loading,
            onClick: onClose,
          },
          {
            text: "Mark Inactive",
            type: "button",
            variant: "primaryDefault",
            disabled: loading,
            onClick: () => onConfirm(),
          },
        ],
      }}
    >
      <p className="text-wrap">
        Setting this form to inactive will disable all links, QR codes, and web{" "}
        {terms.enquiry.plural}. They will no longer work, and no submissions
        will be received.
      </p>
      <p>If the form is reactivated, they will resume working.</p>
    </Modal>
  );
};
